<template>
    <div class="m-labels__product m-labels-products d-flex">
        <div
            class="m-labels__product mp-promos__productWrapper mp-promos__productWrapperModal d-flex"
            :id="`mp-promos__productWrapper-${pKey}`"
        >
            <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                    <ui-checkbox-input
                        :name="`g${groupId}-p${promoId}-${pKey}`"
                        :value="product.downloadLabel"
                        @change="onProductCheckChange"
                    />
                    <div v-if="imgPath" class="c-fig c-fig--promos c-fig--product">
                        <img
                            alt
                            class="c-fig__img"
                            :src="imgPath"
                        />
                    </div>
                    <div class="mb-0 ml-3">
                        <h6
                            v-text="dictProduct.name"
                            class="text-break mb-0"
                            :style="{
                                fontWeight: product.downloadLabel
                                    ? '700'
                                    : '400'
                            }"
                        />
                        <span style="font-size: 0.75rem">EAN: {{ product.ean || dictProduct.ean }}</span>
                    </div>
                </div>
                <div
                    v-if="hasExtraFields"
                    class="form-group button-extra-fields align-items-center d-md-none d-flex m-0"
                    :id="`m-labels__btnExtraFields-${pKey}`"
                >
                    <the-btn
                        class="ml-2 mt-0 pl-2 pr-2 btn-outline-custom"
                        @click.native="showExtraFields"
                    >
                        <a-icon icon="Filter" />
                    </the-btn>
                </div>
            </div>

            <div
                v-if="showPriceLowest"
                class="input-currency input-currency-sm d-flex align-items-center justify-content-between gap-0-5"
            >
                <label
                    class="d-md-none form-label d-flex"
                    :for="`input-lowest-${activeKey}-prod-${pKey}`"
                >
                    <span>Cena z 30 dni</span>

                    <a-icon
                        icon="Info"
                        width="16"
                        height="16"
                        v-tooltip="{
                            content: $store.getters.isWeight(promo.type)
                                ? 'Najniższa cena przed obniżką'
                                : 'Najniższa cena towaru z 30 dni przed obniżką'
                        }"
                    />
                </label>

                <money-input
                    :invalid="!!isMandatoryPriceError('noPriceLowest')"
                    :id="`input-lowest-${activeKey}-prod-${pKey}`"
                    :placeholder="+priceLowest"
                    :price="priceOmnibus"
                    @onChange="priceLowest = $event"
                />
            </div>

            <div
                v-if="!product.open && showPrice"
                class="input-currency input-currency-sm d-flex align-items-center justify-content-between gap-0-5"
            >
                <label
                    :for="`input-${activeKey}-prod-${pKey}`"
                    class="d-md-none form-label"
                >
                    {{
                        $store.getters.isWeight(promo.type)
                            ? 'Cena za kg poza promocją'
                            : 'Cena poza promocją'
                    }}
                </label>
                <money-input
                    class="my-0"
                    :id="`input-${activeKey}-prod-${pKey}`"
                    :placeholder="+productPrices"
                    :price="+productPrices"
                    :max-value="$store.getters.getLabelMaxPrice"
                    :positive-number-validation="false"
                    :small="true"
                    :invalid="!!isMandatoryPriceError('noPriceNormal')"
                    @onChange="productPrices = $event"
                    @onValidate="$emit('changeDefaultPrice')"
                />
            </div>

            <div
                v-if="showPriceLowestDiscount"
                class="input-currency input-currency-sm d-flex align-items-center justify-content-between gap-0-5"
            >
                <label
                    :for="`input-lowest-discount-${activeKey}-prod-${pKey}`"
                    class="d-md-none form-label"
                >
                    Cena za kg sprzed obniżki
                </label>

                <money-input
                    class="my-0"
                    :validate="false"
                    :id="`input-lowest-discount-${activeKey}-prod-${pKey}`"
                    :price="extraFieldValue('price_lowest_discount')"
                    :placeholder="+extraFieldValue('price_lowest_discount')"
                    :invalid="!!isMandatoryPriceError('noWeightPriceNormal')"
                    @onChange="onExtraFieldChange({
                        name: 'price_lowest_discount',
                        type: $options.types.FLOAT
                    }, +$event)"
                />
            </div>

            <div
                v-if="!product.open"
                class="input-copies d-flex align-items-center justify-content-between gap-0-5"
            >
                <label
                    class="form-label d-md-none mb-0"
                    :for="`input-${activeKey}-copies-${pKey}`"
                >
                    Liczba kopii
                </label>

                <input
                    v-model="productCopies"
                    class="form-control form-control-sm"
                    type="number"
                    step="1"
                    min="1"
                    oninput="validity.valid||(value='')"
                    :id="`input-${activeKey}-copies-${pKey}`"
                />
            </div>
            <div
                v-if="hasExtraFields"
                class="form-group button-extra-fields align-items-center d-md-flex d-none m-0"
                :id="`m-labels__btnExtraFields-${pKey}`"
            >
                <the-btn
                    @click.native="showExtraFields"
                    :style="'width: 58px; max-width: 58px'"
                    class="ml-0 mt-0 pl-3 pr-3 btn-outline-custom"
                ><a-icon icon="Filter" /></the-btn>
            </div>
            <slot
                v-if="
                    !hasExtraFields ||
                        (hasExtraFields && isShowMoreBtn(true, false))
                "
                name="showMoreBtn"
            ></slot>
        </div>
        <div
            v-if="product.showExtraFields"
            class="m-labels__extraFields pt-3 pb-3"
            :id="`m-labels__extraFields-${pKey}`"
            :class="{
                '--elems-3': payloadAttributes.length > 2
            }"
        >
            <the-input
                v-for="(attribute, aIdx) in payloadAttributes"
                invalid-feedback=""
                :label="$options.PRICE_TAGS_ATTRIBUTES[attribute.name] || attribute.name"
                :text="extraFieldValue(attribute.name)"
                :key="aIdx"
                :invalid="
                    extraFieldValue(attribute.name) === '' ||
                        $store.getters.getWeightProductError({
                            groupId,
                            promoId,
                            productId: product.id,
                            field: attribute.name
                        })
                "
                @input="onExtraFieldChange(attribute, $event)"
            >
                {{ attribute.name }}
            </the-input>
        </div>

        <slot
            v-if="hasExtraFields && isShowMoreBtn(false, true)"
            name="showMoreBtn"
        />

        <slot />
    </div>
</template>

<script>
import priceTagsAttributes from '@/dictionaries/price-tags-attributes'
import UiCheckboxInput from '../global/ui/UiCheckboxInput.vue'
import { TYPES } from '@/helpers/type-converter.js'

const UNSUPPORTED_ATTRIBUTES = [
    'variant',
    'promo_dict_product_subscription_id',
    'print_copies',
    'ean',
    'price_lowest',
    'price_lowest_discount',
    'price_normal'
]

export default {
    types: TYPES,
    PRICE_TAGS_ATTRIBUTES: priceTagsAttributes,
    data() {
        return {
            searchMerchants: '',
            allowChangePrice: false
        }
    },
    props: {
        product: {
            type: Object,
            required: true
        },
        promo: {
            type: Object,
            required: true
        },
        pKey: {
            type: Number,
            required: true
        },
        promoId: {
            type: Number,
            required: true
        },
        groupId: {
            type: Number,
            required: true
        },
        activeKey: {
            type: Number,
            required: true
        },
        groupIdx: {
            type: Number,
            required: false
        },
        merchantId: {
            type: Number,
            required: false
        },
        showPrice: {
            type: Boolean,
            default: true
        },
        setExtraFieldsScroll: {
            type: Function,
            default: () => {}
        },
        showPriceLowest: {
            type: Boolean,
            default: false
        },
        showPriceLowestDiscount: {
            type: Boolean,
            default: false
        }
    },
    components: {
        UiCheckboxInput
    },
    computed: {
        dictProduct() {
            return this.product.dict_product || {}
        },
        promotionShops() {
            return this.$store.getters.getPromotionLabelShops({
                promoId: this.promoId,
                groupId: this.groupId
            })
        },
        searchedShops() {
            return this.promotionShops
                .filter(el => el !== undefined && el.state === 'accepted')
                .map(el => el.merchant_id)
        },
        priceTags() {
            return this.$store.getters.getPriceTags
        },
        isProductChecked() {
            return !!this.priceTags.find(
                pt =>
                    pt.promotion_id === this.promoId &&
                    pt.product_id === this.pKey
            )
        },
        productPrices: {
            get() {
                const { price_default, productPrice, subscriptions } = this.product

                let productPrices
                if (productPrice) {
                    // 1. Use productPrice if available
                    productPrices = productPrice
                } else if (subscriptions) {
                    // 2. If subscriptions exist, check if all price_normal values are equal
                    const prices = Object.values(subscriptions)
                        .map(el => (el.price_normal ? +el.price_normal : 0))

                    if (prices.every(v => v === prices[0])) {
                        // All prices are equal, use that value
                        productPrices = prices[0]
                    } else {
                        // Not all prices are equal, open product for manual input
                        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                        this.product.open = true
                        productPrices = null
                    }
                }
                // 3. Fallback to price_default if productPrices is still null
                return productPrices || price_default || 0
            },
            set(val) {
                this.$store.dispatch('setSubscriptionProductPrice', {
                    product: this.product,
                    newPrice: val,
                    merchantId: this.merchantId,
                    groupIdx: this.groupIdx,
                    groupId: this.groupId,
                    fromLabels: true,
                    promo: this.promo
                })
                this.onProductCheckChange(true)
            }
        },
        productCopies: {
            get() {
                return this.product.print_copies ? this.product.print_copies : 1
            },
            set(val) {
                this.$store.dispatch('setSubscriptionProductCopies', {
                    promoId: this.promoId,
                    product: this.product,
                    copies: +val,
                    merchantId: this.merchantId,
                    groupIdx: this.groupIdx,
                    groupId: this.groupId
                })
                this.onProductCheckChange(true)
            }
        },
        priceLowest: {
            get() {
                return this.product.priceLowest || this.product.price_lowest || 0
            },
            set(val) {
                this.$store.dispatch('setSubscriptionProductPriceLowest', {
                    product: this.product,
                    priceLowest: val,
                    merchantId: this.merchantId,
                    groupIdx: this.groupIdx,
                    groupId: this.groupId,
                    fromLabels: true,
                    promo: this.promo
                })
                this.onProductCheckChange(true)
            }
        },
        hasExtraFields() {
            return this.payloadAttributes.length > 0
        },
        productVariant() {
            return this.dictProduct.dict_product_type?.price_tag_type?.variants.find(
                v => v.promo_type === this.promo.type
            )
        },
        isEqualPrices() {
            return this.promo.subscriptionsEqualPrices.equalPrices
        },
        priceOmnibus() {
            // If priceLowest is set and differs from price_lowest, return priceLowest
            if (
                this.product.price_lowest !== undefined &&
                this.product.price_lowest !== this.priceLowest
            ) {
                return +this.product.price_lowest
            }

            if (!this.isEqualPrices) {
                // Fallback: return product's price_lowest
                return this.product.price_lowest
            }

            // If all subscriptions in the group have equal prices
            const priceGroups = this.promo.subscriptionsEqualPrices.priceGroups
            const group = priceGroups[this.groupIdx]
            if (!group || group.length === 0) {
                return null
            }

            // Find the first product in the first subscription matching the current product
            const firstProduct = group[0].products.find(
                product => product.id === this.product.product_id
            )
            // Get the lowest price from the first product (prefer priceLowest, fallback to price_lowest)
            const firstProductPrice = firstProduct
                ? +firstProduct.priceLowest || +firstProduct.price_lowest
                : null

            // Check if all subscriptions in the group have the same price for this product
            const allEqual = group.every(subscription => {
                const product = subscription.products.find(
                    product => product.id === this.product.product_id
                )
                // Compare both price_lowest and priceLowest for robustness
                return product
                    ? +product.price_lowest === firstProductPrice ||
                              +product.priceLowest === firstProductPrice
                    : false
            })

            return allEqual ? firstProductPrice : null
        },
        payloadAttributes() {
            if (!this.promo.designSources) {
                return []
            }

            const designSource = this.promo.designSources.find(ds =>
                ds.source_id.includes(this.dictProductSubscriptionId)
            )

            if (!designSource) {
                return []
            }

            const attributes = designSource.design.payload || []

            return attributes.filter(attr => !UNSUPPORTED_ATTRIBUTES.includes(attr.name))
        },
        imgPath() {
            return this.dictProduct.image?.urls?.small
        },
        dictProductSubscriptionId() {
            if ((this.product.product_subscriptions || []).length === 0) {
                return null
            }
            return this.product.product_subscriptions[0].id
        }
    },
    methods: {
        showExtraFields() {
            this.$store.dispatch('setProductShowExtraFields', {
                promoId: this.promoId,
                productId: this.product.id,
                showExtraFields: !this.product.showExtraFields,
                merchantId: this.merchantId,
                groupIdx: this.groupIdx,
                groupId: this.groupId
            })
            this.setExtraFieldsScroll()
        },
        extraFieldValue(name) {
            let sub
            if (this.isEqualPrices) {
                sub = this.promo.subscriptionsEqualPrices.priceGroups[
                    this.groupIdx
                ][0]
            } else {
                sub = this.promo.subscriptions.find(
                    el => el.merchant_id === this.merchantId
                )
            }
            const prod = sub.products.find(el => el.id === this.product.id)
            return prod.payload && prod.payload[name] ? prod.payload[name] : ''
        },
        onProductPriceChange(price) {
            this.$store.dispatch('setSubscriptionProductPrice', {
                promo: this.promo,
                product: this.product,
                newPrice: price,
                merchantId: this.merchantId,
                groupIdx: this.groupIdx,
                groupId: this.groupId,
                fromLabels: true
            })
            this.onProductCheckChange(true)
        },
        onProductCheckChange(selected) {
            this.$store.dispatch('changeProductLabelDownloadState', {
                selected,
                groupId: this.groupId,
                promoId: this.promoId,
                merchantId: this.merchantId,
                product: this.product
            })
        },
        onExtraFieldChange(attribute, value) {
            this.$store.dispatch('setSubscriptionProductFreshAttribute', {
                promoId: this.promoId,
                productId: this.product.id,
                merchantId: this.merchantId,
                groupIdx: this.groupIdx,
                groupId: this.groupId,
                fromLabels: true,
                attribute,
                value
            })
        },
        isShowMoreBtn(mediaBreakpointUpMd, mediaBreakpointDownMd) {
            return (
                (mediaBreakpointDownMd && window.innerWidth < 768) ||
                (mediaBreakpointUpMd && window.innerWidth >= 768)
            )
        },
        isMandatoryPriceError(errorCode) {
            const shouldValidate = !this.$store.getters
                .getMandatoryPriceValidation
            const error = this.$store.getters.getMandatoryPriceError({
                promoId: this.promoId,
                groupId: this.groupId,
                productId: this.product.id,
                merchantId: this.merchantId,
                type: errorCode
            })
            if (error?.type === errorCode && shouldValidate) {
                return null
            } else {
                return error
            }
        }
    },
    watch: {
        productPrices(val) {
            if (this.allowChangePrice) {
                Object.values(this.product.subscriptions).forEach(el => {
                    el.price_normal = val
                })
                Object.values(this.searchedShops).forEach(shop => {
                    shop.price_normal = val
                })
            }
        },
        hasExtraFields: {
            handler(val) {
                this.$emit('has-extra-fields', val)
            },
            immediate: true
        }
    },
    created() {
        if (!this.product.print_copies) {
            this.productCopies = this.product.print_default || 1
        }
    },
    mounted() {
        if (window.innerWidth < 768) {
            const showMoreBtn = document.querySelector(
                `#showMoreBtn-${this.pKey}`
            )
            const productWrapper = document.querySelector(
                `#mp-promos__productWrapper-${this.pKey}`
            )
            const productWrapperHeight = productWrapper
                ? productWrapper.offsetHeight
                : null
            if (showMoreBtn && productWrapperHeight) {
                showMoreBtn.style = `
                    top: ${productWrapperHeight}px;
                    bottom: auto;
                    min-width: 100%;
                    margin-bottom: ${this.hasExtraFields ? '1rem' : 0};
                    position: sticky;
                    z-index: 1000;
                `
            }
        }
    }
}
</script>
